import {DeviceInfo} from 'qunar-react-native'

export interface DefaultConfigItemModel {
    title: string;
    value: string;
    id: string;
    default?: boolean;
    checked?: boolean;
    tag?: string;
}

const defaultConfig: DefaultConfigItemModel[] = [
    {
        title: '全部',
        value: 'all',
        tag: global.orderAccessibilityLabelName.TAB_ALL,
        id: 'all',
        default: true,
        checked: true
    },
    {
        title: '待出行',
        value: 'readygo',
        tag: global.orderAccessibilityLabelName.TAB_READY_GO,
        id: 'readygo'
    },
    {
        title: '待支付',
        value: '10,11',
        tag: global.orderAccessibilityLabelName.TAB_NO_PAY,
        id: 'pay'
    },
    {
        title: '退款单',
        id: 'refund',
        tag: global.orderAccessibilityLabelName.TAB_REFUND,
        value: '1010,1020,1030,1040,1050,200010,200020,100100,700030,600010'
    }
];
const needCommentConfig = Array.from(defaultConfig);
needCommentConfig.splice(3, 0, {
    title: '待点评',
    value: 'needComment',
    tag: global.orderAccessibilityLabelName.TAB_NO_COMMENT,
    id: 'needComment'
});
const allConfig = Array.from(defaultConfig);
allConfig.splice(3, 1, {
    title: '退款/售后',
    id: 'refund',
    tag: global.orderAccessibilityLabelName.TAB_REFUND,
    value: '1010,1020,1030,1040,1050,200010,200020,100100,700030,600010'
});
const needCommentAllConfig = Array.from(allConfig);
needCommentAllConfig.splice(3, 0, {
    title: '待点评',
    value: 'needComment',
    tag: global.orderAccessibilityLabelName.TAB_NO_COMMENT,
    id: 'needComment'
});

const STATUS_BAR_DATA_MAP: { [propName: string]: DefaultConfigItemModel[] } = {
    flight: [
        {
            title: '全部',
            value: 'all',
            default: true,
            checked: true,
            tag: global.orderAccessibilityLabelName.TAB_ALL,
            id: 'all'
        },
        {
            title: '待支付',
            value: '10',
            tag: global.orderAccessibilityLabelName.TAB_NO_PAY,
            id: 'pay'
        },
        {
            title: '待出票',
            value: '30',
            tag: global.orderAccessibilityLabelName.TAB_NO_TICKETED,
            id: 'ticketing'
        },
        {
            title: '已出票',
            value: '50',
            tag: global.orderAccessibilityLabelName.TAB_READY_TICKETED,
            id: 'ticketed'
        },
        {
            title: '退款单',
            value: '1010,1020,1030,1040,1050,200010,200020',
            tag: global.orderAccessibilityLabelName.TAB_REFUND_CHANGED,
            id: 'refund'
        }
    ],
    all: DeviceInfo.isNotRn ? allConfig : needCommentAllConfig,
    hotelAll: DeviceInfo.isNotRn ? defaultConfig : needCommentConfig,
    hotel: defaultConfig,
    bus: defaultConfig,
    train: defaultConfig,
    sight: defaultConfig,
    food: defaultConfig,
    ddr: defaultConfig,
    orderinsure: defaultConfig,
    qmall: defaultConfig,
    carcar: defaultConfig,
    shopping: defaultConfig,
    pack: defaultConfig,
    qstar: defaultConfig
};

const getStatusDataById = (businessId: string, statusId: string) => {
    const curStatusBarData = STATUS_BAR_DATA_MAP[businessId];
    const len = curStatusBarData.length;
    for (let i = 0; i < len; i++) {
        if (statusId === curStatusBarData[i].id) {
            return curStatusBarData[i];
        }
    }
};

export { getStatusDataById, STATUS_BAR_DATA_MAP };
